import {Injectable} from '@angular/core';

import {SearchApi} from '../api/rest/search.restapi';
import {ProjectId, ResourceId} from '../types/ids';
import {Observable, of, Subject} from 'rxjs';
import {isDefined} from '../utils/utils';
import {Feedable, SearchResults} from '../types/searchresult';
import {EventsService} from '@webmate-web-core/shared/services/events/events.service';
import {filter, map} from 'rxjs/operators';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class SearchService {


    constructor (public api: SearchApi, private eventService: EventsService) {}

    simpleSearch(projectId: ProjectId, query: string, from?: number, size?: number, resourceType?: string): Observable<SearchResults> {
        return this.api.simpleSearch(projectId, query, from, size, resourceType);
    }

    getFeedable(projectId: ProjectId, resourceId: ResourceId): Observable<Feedable> {
        return this.api.getFeedable(projectId, resourceId);
    }

    private indexingSubjects: {[s: string /*ProjectId*/]: Subject<boolean>} = {};

    getIndexingNotifications(projectId: ProjectId): Observable<boolean> {
        if (!this.indexingSubjects[projectId]) {
            this.indexingSubjects[projectId] = new Subject();
            this.eventService.getEventsForProject(projectId).pipe(
                filter(e => e.eventType === "Search.IndexUpdated")
            ).subscribe(() => this.indexingSubjects[projectId].next(true));
        }
        return this.indexingSubjects[projectId].asObservable();
    }

    getChangedNotification(projectId: ProjectId, resourceType?: string): Observable<ResourceId[]> {
        // only listen for index updated events
        // calculate resourceids for resourceType or all
        return this.eventService.getEventsForProject(projectId).pipe(
            filter(e => e.eventType === "Search.IndexUpdated"),
            filter(e => resourceType ? e.docsByType[resourceType] : true),
            map(e => {
                if (resourceType) return e.docsByType[resourceType];
                return _.flatten( _.values(e.docsByType));
            })
        );
    }

    getDeletedNotification(projectId: ProjectId): Observable<ResourceId> {
        return this.eventService.getEventsForProject(projectId).pipe(
            filter(e => e.eventType === "Search.FeedableDeleted"),
            map(e => e.id)
        );
    }

}
